import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useScreenPermissions } from './useScreenPermissions';
import { routeToScreenCode } from './ScreenRoutes';

const ProtectedRoute = ({ children, screenCode }) => {
  const { hasScreenAccess, loading } = useScreenPermissions();
  const location = useLocation();

  if (loading) {
    return <div>Loading permissions...</div>;
  }

  // Get screen code from props or route
  const currentScreenCode = screenCode || routeToScreenCode[location.pathname];
  
  if (!currentScreenCode) {
    return <Navigate to="/dashboard" replace />;
  }
  
  // --- CHECK ONLY: ScreenAccess ---
  // If ScreenAccess is FALSE, redirect.
  // If ScreenAccess is TRUE, render the children (the List Page).
  if (!hasScreenAccess(currentScreenCode)) {
    console.log(`Access denied: ScreenAccess is false for ${currentScreenCode}`);
    return <Navigate to="/dashboard" state={{ from: location }} replace />;
  }
  
  // We NO LONGER check CanView here. 
  // This allows the user to load the main page (List) even if they can't view specific items.
  return children;
};

export default ProtectedRoute;